import { Link } from 'react-router-dom';
import { useEffect } from 'react';

export default function ListSuccessPage() {
  const sessionId = new URLSearchParams(window.location.search).get('session_id');

  useEffect(() => {
    fetch('/.netlify/functions/events', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ name: 'checkout_completed_page_viewed', properties: { purchase_type: 'new_listing', session_id: sessionId || '' } }),
      keepalive: true,
    }).catch(() => undefined);
  }, [sessionId]);

  return (
    <div className="max-w-[800px] mx-auto px-4 md:px-8 py-16 md:py-24 text-center">
      <div className="text-5xl mb-5">✅</div>
      <h1 className="font-display text-2xl md:text-3xl font-bold mb-3">Your MarineLink listing is on its way</h1>
      <p className="text-text-secondary leading-relaxed max-w-[560px] mx-auto mb-8">
        Thanks for joining MarineLink. We’ve received your payment and will activate your selected visibility plan once the payment confirmation is processed.
      </p>
      <div className="flex items-center justify-center gap-3 flex-wrap">
        <Link to="/" className="btn btn-primary">Back to MarineLink</Link>
        <Link to="/signin" className="btn btn-ghost">Manage your listing</Link>
      </div>
    </div>
  );
}
